<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Add'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 32px
  height 32px
  background-size 32px 32px
  background-repeat no-repeat
  background-position center
  background-image url('./images/h5_payment_icon_address@3x.png')
}
</style>
